// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// JLPT level (1-5, where 5 = N5/easiest and 1 = N1/hardest) for each jōyō
// kanji, or null if it isn't part of any level. Since the JLPT stopped
// publishing an official kanji list after its 2010 revision, this uses the
// widely-used unofficial list served by kanjiapi.dev (https://kanjiapi.dev),
// cross-checked against Jisho.org's own JLPT tagging for a sample of kanji
// across every level.
export const kanjiJlptLevels = {
    "亜": 1,
    "哀": 1,
    "挨": null,
    "愛": 3,
    "曖": null,
    "悪": 4,
    "握": 1,
    "圧": 2,
    "扱": 1,
    "宛": null,
    "嵐": 1,
    "安": 4,
    "案": 1,
    "暗": 3,
    "以": 4,
    "衣": 2,
    "位": 3,
    "囲": 2,
    "医": 4,
    "依": 2,
    "委": 2,
    "威": 1,
    "為": 1,
    "畏": null,
    "胃": 2,
    "尉": 1,
    "異": 1,
    "移": 2,
    "萎": null,
    "偉": 3,
    "椅": null,
    "彙": null,
    "意": 4,
    "違": 3,
    "維": 1,
    "慰": 1,
    "遺": 1,
    "緯": 1,
    "域": 2,
    "育": 3,
    "一": 5,
    "壱": 1,
    "逸": 1,
    "茨": null,
    "芋": 1,
    "引": 3,
    "印": 2,
    "因": 3,
    "咽": null,
    "姻": 1,
    "員": 4,
    "院": 4,
    "淫": null,
    "陰": 1,
    "飲": 4,
    "隠": 1,
    "韻": 1,
    "右": 5,
    "宇": 2,
    "羽": 2,
    "雨": 5,
    "唄": 1,
    "鬱": null,
    "畝": 1,
    "浦": 1,
    "運": 4,
    "雲": 2,
    "永": 2,
    "泳": 3,
    "英": 4,
    "映": 4,
    "栄": 2,
    "営": 2,
    "詠": 1,
    "影": 1,
    "鋭": 2,
    "衛": 1,
    "易": 3,
    "疫": 1,
    "益": 1,
    "液": 2,
    "駅": 4,
    "悦": 1,
    "越": 3,
    "謁": 1,
    "閲": 1,
    "円": 5,
    "延": 2,
    "沿": 1,
    "炎": 1,
    "怨": null,
    "宴": 1,
    "媛": 1,
    "援": 1,
    "園": 3,
    "煙": 3,
    "猿": 1,
    "遠": 3,
    "鉛": 1,
    "塩": 2,
    "演": 3,
    "縁": 1,
    "艶": 1,
    "汚": 2,
    "王": 3,
    "凹": 1,
    "央": 2,
    "応": 1,
    "往": 1,
    "押": 3,
    "旺": 1,
    "欧": 2,
    "殴": 1,
    "桜": 1,
    "翁": 1,
    "奥": 2,
    "横": 3,
    "岡": null,
    "屋": 4,
    "億": 2,
    "憶": 1,
    "臆": null,
    "虞": 1,
    "乙": 1,
    "俺": null,
    "卸": 1,
    "音": 4,
    "恩": 1,
    "温": 2,
    "穏": 1,
    "下": 5,
    "化": 3,
    "火": 5,
    "加": 3,
    "可": null,
    "仮": 1,
    "何": 5,
    "花": 4,
    "佳": 1,
    "価": 1,
    "果": 3,
    "河": 2,
    "苛": null,
    "科": 3,
    "架": 1,
    "夏": 4,
    "家": 4,
    "荷": 2,
    "華": 1,
    "菓": 2,
    "貨": 2,
    "渦": 1,
    "過": 3,
    "嫁": 1,
    "暇": 1,
    "禍": 1,
    "靴": 3,
    "寡": 1,
    "歌": 4,
    "箇": 1,
    "稼": 1,
    "課": 2,
    "蚊": 1,
    "牙": null,
    "瓦": null,
    "我": 1,
    "画": 4,
    "芽": 1,
    "賀": 1,
    "雅": 1,
    "餓": 1,
    "介": 2,
    "回": 3,
    "灰": 2,
    "会": 4,
    "快": 2,
    "戒": 1,
    "改": 2,
    "怪": 1,
    "拐": 1,
    "悔": 1,
    "海": 4,
    "界": 4,
    "皆": 3,
    "械": 2,
    "絵": 3,
    "開": 4,
    "階": 2,
    "塊": 1,
    "楷": null,
    "解": 3,
    "潰": null,
    "壊": 1,
    "懐": 1,
    "諧": null,
    "貝": 2,
    "外": 5,
    "劾": 1,
    "害": 3,
    "崖": null,
    "涯": 1,
    "街": 1,
    "慨": 1,
    "蓋": null,
    "該": 1,
    "概": 1,
    "骸": null,
    "垣": 1,
    "柿": null,
    "各": 2,
    "角": 2,
    "拡": 1,
    "革": 2,
    "格": 3,
    "核": 1,
    "殻": 1,
    "郭": 1,
    "覚": 3,
    "較": 1,
    "隔": 1,
    "閣": 1,
    "確": 3,
    "獲": 1,
    "嚇": 1,
    "穫": 1,
    "学": 5,
    "岳": 1,
    "楽": 4,
    "額": 2,
    "顎": null,
    "掛": 3,
    "潟": 1,
    "括": 1,
    "活": 3,
    "喝": 1,
    "渇": 1,
    "割": 3,
    "葛": null,
    "滑": 1,
    "褐": 1,
    "轄": 1,
    "且": 1,
    "株": 1,
    "釜": null,
    "鎌": 1,
    "刈": 1,
    "干": 2,
    "刊": 2,
    "甘": 2,
    "汗": 2,
    "缶": 2,
    "完": 3,
    "肝": 1,
    "官": 3,
    "冠": 1,
    "巻": 2,
    "看": 1,
    "陥": 1,
    "乾": 2,
    "勘": 1,
    "患": 2,
    "貫": 1,
    "寒": 3,
    "喚": 1,
    "堪": 1,
    "換": 2,
    "敢": 1,
    "棺": 1,
    "款": 1,
    "間": 5,
    "閑": 1,
    "勧": 1,
    "寛": 1,
    "幹": 1,
    "感": 3,
    "漢": 4,
    "慣": 3,
    "管": 2,
    "関": 3,
    "歓": 1,
    "監": 1,
    "緩": 1,
    "憾": 1,
    "還": 1,
    "館": 4,
    "環": 1,
    "簡": 2,
    "観": 3,
    "韓": null,
    "艦": 1,
    "鑑": 1,
    "丸": 2,
    "含": 2,
    "岸": 2,
    "岩": 2,
    "玩": null,
    "眼": 1,
    "頑": 1,
    "顔": 3,
    "願": 3,
    "企": 1,
    "伎": 1,
    "危": 3,
    "机": 2,
    "気": 5,
    "岐": 1,
    "希": 2,
    "忌": 1,
    "汽": 1,
    "奇": 1,
    "祈": 2,
    "季": 2,
    "紀": 1,
    "軌": 1,
    "既": 1,
    "記": 3,
    "起": 4,
    "飢": 1,
    "鬼": 1,
    "帰": 4,
    "基": 1,
    "寄": 3,
    "規": 3,
    "亀": 1,
    "喜": 3,
    "幾": 3,
    "揮": 1,
    "期": 3,
    "棋": 1,
    "貴": 1,
    "棄": 1,
    "毀": null,
    "旗": 1,
    "器": 1,
    "畿": null,
    "輝": 1,
    "機": 3,
    "騎": 1,
    "技": 2,
    "宜": 1,
    "偽": 1,
    "欺": 1,
    "義": 1,
    "疑": 3,
    "儀": 1,
    "戯": 1,
    "擬": 1,
    "犠": 1,
    "議": 3,
    "菊": 1,
    "吉": 1,
    "喫": 2,
    "詰": 2,
    "却": 1,
    "客": 3,
    "脚": 1,
    "逆": 2,
    "虐": 1,
    "九": 5,
    "久": 2,
    "及": 1,
    "弓": 1,
    "丘": 1,
    "旧": 2,
    "休": 5,
    "吸": 3,
    "朽": 1,
    "臼": null,
    "求": 3,
    "究": 4,
    "泣": 1,
    "急": 4,
    "級": 1,
    "糾": 1,
    "宮": 1,
    "救": 1,
    "球": 3,
    "給": 3,
    "嗅": null,
    "窮": 1,
    "牛": 4,
    "去": 4,
    "巨": 2,
    "居": 3,
    "拒": 1,
    "拠": 1,
    "挙": 1,
    "虚": 1,
    "許": 3,
    "距": 1,
    "魚": 4,
    "御": 3,
    "漁": 2,
    "凶": 1,
    "共": 3,
    "叫": 2,
    "狂": 1,
    "京": 4,
    "享": 1,
    "供": 3,
    "協": 2,
    "況": 2,
    "峡": 1,
    "挟": 2,
    "狭": 1,
    "恐": 3,
    "恭": 1,
    "胸": 2,
    "脅": 1,
    "強": 4,
    "教": 4,
    "郷": 1,
    "境": 2,
    "橋": 2,
    "矯": 1,
    "鏡": 1,
    "競": 2,
    "響": 1,
    "驚": 1,
    "仰": 1,
    "暁": 1,
    "業": 4,
    "凝": 1,
    "曲": 3,
    "局": 3,
    "極": 2,
    "玉": 2,
    "巾": null,
    "斤": 1,
    "均": 2,
    "近": 4,
    "金": 5,
    "菌": 1,
    "勤": 3,
    "琴": 1,
    "筋": 1,
    "僅": null,
    "禁": 2,
    "緊": 1,
    "錦": 1,
    "謹": 1,
    "襟": 1,
    "吟": 1,
    "銀": 4,
    "区": 2,
    "句": 1,
    "苦": 3,
    "駆": 1,
    "具": 3,
    "惧": null,
    "愚": 1,
    "空": 4,
    "偶": 3,
    "遇": 1,
    "隅": 2,
    "串": null,
    "屈": 1,
    "掘": 2,
    "窟": null,
    "熊": 1,
    "繰": 1,
    "君": 3,
    "訓": 2,
    "勲": 1,
    "薫": 1,
    "軍": 2,
    "郡": 1,
    "群": 2,
    "兄": 4,
    "刑": 1,
    "形": 3,
    "系": 1,
    "径": 1,
    "茎": 1,
    "係": 3,
    "型": 2,
    "契": 1,
    "計": 4,
    "恵": 1,
    "啓": 1,
    "掲": 1,
    "渓": 1,
    "経": 3,
    "蛍": 1,
    "敬": 2,
    "景": 3,
    "軽": 2,
    "傾": 2,
    "携": 1,
    "継": 1,
    "詣": null,
    "慶": 1,
    "憬": null,
    "稽": null,
    "憩": 1,
    "警": 3,
    "鶏": 1,
    "芸": 2,
    "迎": 3,
    "鯨": 1,
    "隙": null,
    "劇": 2,
    "撃": 1,
    "激": 1,
    "桁": null,
    "欠": 3,
    "穴": 1,
    "血": 2,
    "決": 3,
    "結": 1,
    "傑": 1,
    "潔": 1,
    "月": 5,
    "犬": 4,
    "件": 3,
    "見": 5,
    "券": 2,
    "肩": 2,
    "建": 4,
    "研": 4,
    "県": 2,
    "倹": 1,
    "兼": 1,
    "剣": 1,
    "拳": 1,
    "軒": 2,
    "健": 1,
    "険": 3,
    "圏": 1,
    "堅": 1,
    "検": 1,
    "嫌": 1,
    "献": 1,
    "絹": 1,
    "遣": 1,
    "権": 3,
    "憲": 1,
    "賢": 2,
    "謙": 1,
    "鍵": null,
    "繭": 1,
    "顕": 1,
    "験": 4,
    "懸": 1,
    "元": 4,
    "幻": 1,
    "玄": 1,
    "言": 4,
    "弦": 1,
    "限": 3,
    "原": 3,
    "現": 3,
    "舷": null,
    "減": 2,
    "源": 1,
    "厳": 1,
    "己": 1,
    "戸": 2,
    "古": 4,
    "呼": 3,
    "固": 2,
    "股": null,
    "虎": 1,
    "孤": 1,
    "弧": 1,
    "故": 1,
    "枯": 2,
    "個": 2,
    "庫": 2,
    "湖": 2,
    "雇": 2,
    "誇": 1,
    "鼓": 1,
    "錮": null,
    "顧": 1,
    "五": 5,
    "互": 3,
    "午": 5,
    "呉": 1,
    "後": 5,
    "娯": 1,
    "悟": 1,
    "碁": 1,
    "語": 5,
    "誤": 3,
    "護": 1,
    "口": 4,
    "工": 4,
    "公": 4,
    "勾": null,
    "孔": 1,
    "功": 1,
    "巧": 1,
    "広": 4,
    "甲": 1,
    "交": 3,
    "光": 3,
    "向": 3,
    "后": 1,
    "好": 3,
    "江": 1,
    "考": 4,
    "行": 5,
    "坑": 1,
    "孝": null,
    "抗": 1,
    "攻": 1,
    "更": 3,
    "効": 2,
    "幸": 3,
    "拘": 1,
    "肯": 2,
    "侯": 1,
    "厚": 2,
    "恒": 1,
    "洪": 1,
    "皇": 1,
    "紅": 2,
    "荒": 2,
    "郊": 2,
    "香": 2,
    "候": 3,
    "校": 5,
    "耕": 2,
    "航": 2,
    "貢": 1,
    "降": 3,
    "高": 5,
    "康": 1,
    "控": 1,
    "梗": null,
    "黄": 2,
    "喉": null,
    "慌": null,
    "港": 3,
    "硬": 2,
    "絞": 1,
    "項": 1,
    "溝": 1,
    "鉱": 2,
    "構": 3,
    "綱": 1,
    "酵": 1,
    "稿": 1,
    "興": 1,
    "衡": 1,
    "鋼": 1,
    "講": 2,
    "購": 1,
    "乞": null,
    "号": 3,
    "合": 3,
    "拷": 1,
    "剛": 1,
    "傲": null,
    "豪": 1,
    "克": 1,
    "告": 3,
    "谷": 2,
    "刻": 3,
    "国": 5,
    "黒": 4,
    "穀": 1,
    "酷": 1,
    "獄": 1,
    "骨": 2,
    "駒": 1,
    "込": 3,
    "頃": null,
    "今": 5,
    "困": 3,
    "昆": 1,
    "恨": 1,
    "根": 2,
    "婚": 3,
    "混": 2,
    "痕": null,
    "紺": 1,
    "魂": 1,
    "墾": 1,
    "懇": 1,
    "左": 5,
    "佐": 1,
    "沙": 1,
    "査": 2,
    "砂": 2,
    "唆": 1,
    "差": 3,
    "詐": 1,
    "鎖": 1,
    "座": 3,
    "挫": null,
    "才": 3,
    "再": 2,
    "災": 1,
    "妻": 3,
    "采": 1,
    "砕": 1,
    "宰": 1,
    "栽": 1,
    "彩": 1,
    "採": 2,
    "済": 3,
    "祭": 2,
    "斎": 1,
    "細": 2,
    "菜": 2,
    "最": 3,
    "裁": 1,
    "債": 1,
    "催": 1,
    "塞": null,
    "歳": 3,
    "載": 1,
    "際": 3,
    "埼": null,
    "在": 3,
    "材": 2,
    "剤": 1,
    "財": 3,
    "罪": 3,
    "崎": 1,
    "作": 4,
    "削": 1,
    "昨": 3,
    "柵": null,
    "索": 1,
    "策": 1,
    "酢": 1,
    "搾": 1,
    "錯": 1,
    "咲": 2,
    "冊": 2,
    "札": 2,
    "刷": 2,
    "刹": null,
    "拶": null,
    "殺": 3,
    "察": 3,
    "撮": 1,
    "擦": 1,
    "雑": 3,
    "皿": 2,
    "三": 5,
    "山": 5,
    "参": 3,
    "桟": 1,
    "蚕": 1,
    "惨": 1,
    "産": 3,
    "傘": 1,
    "散": 3,
    "算": 2,
    "酸": 1,
    "賛": 3,
    "残": 3,
    "斬": null,
    "暫": 1,
    "士": 1,
    "子": 5,
    "支": 3,
    "止": 4,
    "氏": 1,
    "仕": 4,
    "史": 2,
    "司": 1,
    "四": 5,
    "市": 3,
    "矢": 1,
    "旨": 1,
    "死": 4,
    "糸": 2,
    "至": 1,
    "伺": 2,
    "志": 1,
    "私": 4,
    "使": 4,
    "刺": 2,
    "始": 4,
    "姉": 4,
    "枝": 2,
    "祉": 1,
    "肢": 1,
    "姿": 1,
    "思": 4,
    "指": 3,
    "施": 1,
    "師": 3,
    "恣": null,
    "紙": 4,
    "脂": 2,
    "視": 1,
    "紫": 1,
    "詞": 2,
    "歯": 3,
    "嗣": 1,
    "試": 4,
    "詩": 1,
    "資": 3,
    "飼": 1,
    "誌": 2,
    "雌": 1,
    "摯": null,
    "賜": 1,
    "諮": 1,
    "示": 3,
    "字": 4,
    "寺": 2,
    "次": 3,
    "耳": 3,
    "自": 4,
    "似": 3,
    "児": 2,
    "事": 4,
    "侍": 1,
    "治": 3,
    "持": 4,
    "時": 5,
    "滋": 1,
    "慈": 1,
    "辞": 3,
    "磁": 1,
    "餌": null,
    "璽": null,
    "鹿": 1,
    "式": 3,
    "識": 3,
    "軸": 1,
    "七": 5,
    "𠮟": null,
    "失": 3,
    "室": 4,
    "疾": 1,
    "執": 1,
    "湿": 2,
    "嫉": null,
    "漆": 1,
    "質": 4,
    "実": 3,
    "芝": 1,
    "写": 4,
    "社": 4,
    "車": 5,
    "舎": 1,
    "者": 4,
    "射": 1,
    "捨": 2,
    "赦": 1,
    "斜": 1,
    "煮": 1,
    "遮": 1,
    "謝": 1,
    "邪": 1,
    "蛇": 1,
    "尺": 1,
    "借": 4,
    "酌": 1,
    "釈": 1,
    "爵": 1,
    "若": 3,
    "弱": 2,
    "寂": 1,
    "手": 4,
    "主": 4,
    "守": 3,
    "朱": 1,
    "取": 3,
    "狩": 1,
    "首": 3,
    "殊": 1,
    "珠": 1,
    "酒": 3,
    "腫": null,
    "種": 3,
    "趣": 1,
    "寿": null,
    "受": 3,
    "呪": null,
    "授": 1,
    "需": 1,
    "儒": 1,
    "樹": 1,
    "収": 3,
    "囚": 1,
    "州": 2,
    "舟": 2,
    "秀": 1,
    "周": 2,
    "宗": 1,
    "拾": 2,
    "秋": 4,
    "臭": 1,
    "修": 1,
    "袖": null,
    "終": 4,
    "羞": null,
    "習": 4,
    "週": 4,
    "就": 1,
    "衆": 1,
    "集": 4,
    "愁": 1,
    "酬": 1,
    "醜": 1,
    "蹴": null,
    "襲": 1,
    "十": 5,
    "汁": 1,
    "充": 1,
    "住": 4,
    "柔": 2,
    "重": 4,
    "従": 1,
    "渋": 1,
    "銃": 1,
    "獣": 1,
    "縦": 1,
    "叔": 1,
    "祝": 2,
    "宿": 3,
    "淑": 1,
    "粛": 1,
    "縮": 1,
    "塾": 1,
    "熟": 1,
    "出": 5,
    "述": 2,
    "術": 3,
    "俊": 1,
    "春": 4,
    "瞬": 1,
    "旬": 1,
    "巡": 1,
    "盾": 1,
    "准": 1,
    "殉": 1,
    "純": 2,
    "循": 1,
    "順": 2,
    "準": 2,
    "潤": 1,
    "遵": 1,
    "処": 3,
    "初": 3,
    "所": 3,
    "書": 5,
    "庶": 1,
    "暑": 1,
    "署": 2,
    "緒": 3,
    "諸": 2,
    "女": 5,
    "如": 1,
    "助": 3,
    "序": 1,
    "叙": 1,
    "徐": 1,
    "除": 3,
    "小": 5,
    "升": 1,
    "少": 4,
    "召": 2,
    "匠": 1,
    "床": 2,
    "抄": 1,
    "肖": 1,
    "尚": 1,
    "招": 3,
    "承": 2,
    "昇": 2,
    "松": 1,
    "沼": 1,
    "昭": 1,
    "宵": 1,
    "将": 2,
    "消": 3,
    "症": 1,
    "祥": 1,
    "称": 1,
    "笑": 3,
    "唱": 1,
    "商": 3,
    "渉": 1,
    "章": 2,
    "紹": 2,
    "訟": 1,
    "勝": 3,
    "掌": 1,
    "晶": 1,
    "焼": 2,
    "焦": 1,
    "硝": 1,
    "粧": null,
    "詔": 1,
    "証": 1,
    "象": 2,
    "傷": 1,
    "奨": 1,
    "照": 2,
    "詳": 1,
    "彰": 1,
    "障": 1,
    "憧": 1,
    "衝": 1,
    "賞": 2,
    "償": 1,
    "礁": 1,
    "鐘": 1,
    "上": 5,
    "丈": null,
    "冗": 1,
    "条": 1,
    "状": 3,
    "乗": 3,
    "城": 2,
    "浄": 1,
    "剰": 1,
    "常": 3,
    "情": 3,
    "場": 4,
    "畳": 2,
    "蒸": 2,
    "縄": 1,
    "壌": 1,
    "嬢": 1,
    "錠": 1,
    "譲": 1,
    "醸": 1,
    "色": 4,
    "拭": null,
    "食": 5,
    "植": 2,
    "殖": 1,
    "飾": 1,
    "触": 2,
    "嘱": 1,
    "織": 1,
    "職": 3,
    "辱": 1,
    "尻": null,
    "心": 4,
    "申": 3,
    "伸": 2,
    "臣": 2,
    "芯": null,
    "身": null,
    "辛": 2,
    "侵": 1,
    "信": 3,
    "津": 1,
    "神": 3,
    "唇": 1,
    "娠": 1,
    "振": 1,
    "浸": 1,
    "真": 4,
    "針": 2,
    "深": 3,
    "紳": 1,
    "進": 3,
    "森": 2,
    "診": 1,
    "寝": 3,
    "慎": 1,
    "新": 4,
    "審": 1,
    "震": 2,
    "薪": 1,
    "親": 4,
    "人": 5,
    "刃": 1,
    "仁": 1,
    "尽": 1,
    "迅": 1,
    "甚": 1,
    "陣": 1,
    "尋": 1,
    "腎": null,
    "須": 1,
    "図": 4,
    "水": 5,
    "吹": 3,
    "垂": 1,
    "炊": 1,
    "帥": 1,
    "粋": 1,
    "衰": 1,
    "推": 1,
    "酔": 1,
    "遂": 1,
    "睡": 1,
    "穂": 1,
    "随": 1,
    "髄": 1,
    "枢": 1,
    "崇": 1,
    "数": 3,
    "据": 1,
    "杉": 1,
    "裾": null,
    "寸": 1,
    "瀬": 1,
    "是": 1,
    "井": 1,
    "世": 4,
    "正": 4,
    "生": 5,
    "成": 3,
    "西": 5,
    "声": 3,
    "制": 3,
    "姓": 2,
    "征": 1,
    "性": 3,
    "青": 4,
    "斉": 1,
    "政": 3,
    "星": 2,
    "牲": 1,
    "省": 2,
    "凄": null,
    "逝": 1,
    "清": 2,
    "盛": 1,
    "婿": 1,
    "晴": 3,
    "勢": 2,
    "聖": 1,
    "誠": 1,
    "精": 3,
    "製": 1,
    "誓": 1,
    "静": 3,
    "請": 1,
    "整": 1,
    "醒": null,
    "税": 2,
    "夕": 4,
    "斥": 1,
    "石": 3,
    "赤": 4,
    "昔": 3,
    "析": 1,
    "席": 3,
    "脊": null,
    "隻": 2,
    "惜": 1,
    "戚": null,
    "責": 3,
    "跡": 2,
    "積": 3,
    "績": 2,
    "籍": 2,
    "切": 4,
    "折": 3,
    "拙": 1,
    "窃": 1,
    "接": 2,
    "設": 2,
    "雪": 3,
    "摂": 1,
    "節": 1,
    "説": 3,
    "舌": 1,
    "絶": 3,
    "千": 5,
    "川": 5,
    "仙": 1,
    "占": 2,
    "先": 5,
    "宣": 1,
    "専": 2,
    "泉": 2,
    "浅": 2,
    "洗": 3,
    "染": 1,
    "扇": 1,
    "栓": 1,
    "旋": 1,
    "船": 3,
    "戦": 3,
    "煎": null,
    "羨": null,
    "腺": null,
    "詮": null,
    "践": 1,
    "箋": null,
    "銭": 1,
    "潜": 1,
    "線": 2,
    "遷": 1,
    "選": 3,
    "薦": 1,
    "繊": 1,
    "鮮": 1,
    "全": 3,
    "前": 5,
    "善": 1,
    "然": 3,
    "禅": 1,
    "漸": 1,
    "膳": null,
    "繕": 1,
    "狙": null,
    "阻": 1,
    "祖": 3,
    "租": 1,
    "素": 1,
    "措": 1,
    "粗": 1,
    "組": 3,
    "疎": 1,
    "訴": 1,
    "塑": 1,
    "遡": null,
    "礎": 1,
    "双": 2,
    "壮": 1,
    "早": 4,
    "争": 3,
    "走": 4,
    "奏": 1,
    "相": 3,
    "荘": 1,
    "草": 3,
    "送": 4,
    "倉": 1,
    "捜": 2,
    "挿": 1,
    "桑": 1,
    "巣": 1,
    "掃": 2,
    "曹": 1,
    "曽": null,
    "爽": 1,
    "窓": 3,
    "創": 1,
    "喪": 1,
    "痩": null,
    "葬": 1,
    "装": 2,
    "僧": 1,
    "想": 3,
    "層": 2,
    "総": 2,
    "遭": 1,
    "槽": 1,
    "踪": null,
    "操": 1,
    "燥": 2,
    "霜": 1,
    "騒": 1,
    "藻": 1,
    "造": 2,
    "像": 2,
    "増": 3,
    "憎": 2,
    "蔵": 2,
    "贈": 2,
    "臓": 2,
    "即": 1,
    "束": 3,
    "足": 4,
    "促": 1,
    "則": 2,
    "息": 3,
    "捉": null,
    "速": 3,
    "側": 3,
    "測": 2,
    "俗": 1,
    "族": 4,
    "属": 1,
    "賊": 1,
    "続": 3,
    "卒": 2,
    "率": 1,
    "存": 3,
    "村": 2,
    "孫": 2,
    "尊": 2,
    "損": 2,
    "遜": null,
    "他": 3,
    "多": 4,
    "汰": 1,
    "打": 3,
    "妥": 1,
    "唾": null,
    "堕": 1,
    "惰": 1,
    "駄": 1,
    "太": 3,
    "対": 3,
    "体": 4,
    "耐": 1,
    "待": 4,
    "怠": 1,
    "胎": 1,
    "退": 3,
    "帯": 2,
    "泰": 1,
    "堆": null,
    "袋": 2,
    "逮": 1,
    "替": 2,
    "貸": 4,
    "隊": 1,
    "滞": 1,
    "態": 1,
    "戴": null,
    "大": 5,
    "代": 4,
    "台": 4,
    "第": 1,
    "題": 4,
    "滝": 1,
    "宅": 3,
    "択": 1,
    "沢": 1,
    "卓": 1,
    "拓": 1,
    "託": 1,
    "濯": 2,
    "諾": 1,
    "濁": 1,
    "但": 1,
    "達": 3,
    "脱": 1,
    "奪": 1,
    "棚": 1,
    "誰": null,
    "丹": 1,
    "旦": 1,
    "担": 2,
    "単": 3,
    "炭": 2,
    "胆": 1,
    "探": 3,
    "淡": 1,
    "短": 2,
    "嘆": 1,
    "端": 1,
    "綻": null,
    "誕": 1,
    "鍛": 1,
    "団": 2,
    "男": 5,
    "段": 3,
    "断": 3,
    "弾": 1,
    "暖": 1,
    "談": 3,
    "壇": 1,
    "地": 4,
    "池": 2,
    "知": 4,
    "値": 3,
    "恥": 3,
    "致": 1,
    "遅": 3,
    "痴": 1,
    "稚": 1,
    "置": 3,
    "緻": null,
    "竹": 2,
    "畜": 2,
    "逐": 1,
    "蓄": 1,
    "築": 2,
    "秩": 1,
    "窒": 1,
    "茶": 4,
    "着": 4,
    "嫡": 1,
    "中": 5,
    "仲": 2,
    "虫": 2,
    "沖": 1,
    "宙": 1,
    "忠": 1,
    "抽": 1,
    "注": 4,
    "昼": 4,
    "柱": 2,
    "衷": 1,
    "酎": null,
    "鋳": 1,
    "駐": 2,
    "著": 2,
    "貯": 2,
    "丁": 1,
    "弔": 1,
    "庁": 2,
    "兆": 2,
    "町": 4,
    "長": 5,
    "挑": 1,
    "帳": 1,
    "張": 1,
    "彫": 1,
    "眺": 1,
    "釣": 1,
    "頂": 3,
    "鳥": 4,
    "朝": 4,
    "貼": null,
    "超": 2,
    "腸": 1,
    "跳": 1,
    "徴": 1,
    "嘲": null,
    "潮": 1,
    "澄": 1,
    "調": 3,
    "聴": 1,
    "懲": 1,
    "直": 3,
    "勅": 1,
    "捗": null,
    "沈": 2,
    "珍": 2,
    "朕": 1,
    "陳": 1,
    "賃": 1,
    "鎮": 1,
    "追": 3,
    "椎": 1,
    "墜": 1,
    "通": 4,
    "痛": 3,
    "塚": 1,
    "漬": 1,
    "坪": 1,
    "爪": null,
    "鶴": 1,
    "低": 2,
    "呈": 1,
    "廷": 1,
    "弟": 4,
    "定": 3,
    "底": 2,
    "抵": 1,
    "邸": 1,
    "亭": 1,
    "貞": 1,
    "帝": 1,
    "訂": 1,
    "庭": 3,
    "逓": 1,
    "停": 2,
    "偵": 1,
    "堤": 1,
    "提": 1,
    "程": 3,
    "艇": 1,
    "締": 1,
    "諦": null,
    "泥": 2,
    "的": null,
    "笛": 1,
    "摘": 1,
    "滴": 2,
    "適": 3,
    "敵": 1,
    "溺": null,
    "迭": 1,
    "哲": 1,
    "鉄": 2,
    "徹": 1,
    "撤": 1,
    "天": 5,
    "典": 1,
    "店": 4,
    "点": 3,
    "展": 1,
    "添": 1,
    "転": 4,
    "塡": null,
    "田": 4,
    "伝": 3,
    "殿": 2,
    "電": 5,
    "斗": 1,
    "吐": 1,
    "妬": null,
    "徒": 3,
    "途": 3,
    "都": 3,
    "渡": 3,
    "塗": 2,
    "賭": null,
    "土": 5,
    "奴": 1,
    "努": 3,
    "度": 4,
    "怒": 3,
    "刀": 1,
    "冬": 4,
    "灯": 2,
    "当": 3,
    "投": 3,
    "豆": 1,
    "東": 5,
    "到": 3,
    "逃": 3,
    "倒": 3,
    "凍": 2,
    "唐": null,
    "島": 2,
    "桃": 1,
    "討": 1,
    "透": 1,
    "党": 2,
    "悼": 1,
    "盗": 3,
    "陶": 1,
    "塔": 2,
    "搭": 1,
    "棟": 1,
    "湯": 2,
    "痘": 1,
    "登": 3,
    "答": 4,
    "等": 3,
    "筒": 2,
    "統": 1,
    "稲": 1,
    "踏": 1,
    "糖": 1,
    "頭": 3,
    "謄": 1,
    "藤": 1,
    "闘": 1,
    "騰": 1,
    "同": 4,
    "洞": 1,
    "胴": 1,
    "動": 4,
    "堂": 4,
    "童": 2,
    "道": 4,
    "働": 3,
    "銅": 2,
    "導": 2,
    "瞳": 1,
    "峠": 1,
    "匿": 1,
    "特": 4,
    "得": 3,
    "督": 1,
    "徳": 1,
    "篤": 1,
    "毒": 2,
    "独": 1,
    "読": 5,
    "栃": null,
    "凸": 1,
    "突": 3,
    "届": 2,
    "屯": 1,
    "豚": 1,
    "頓": null,
    "貪": null,
    "鈍": 2,
    "曇": 2,
    "丼": null,
    "那": 1,
    "奈": 1,
    "内": 3,
    "梨": 1,
    "謎": null,
    "鍋": null,
    "南": 5,
    "軟": 2,
    "難": 3,
    "二": 5,
    "尼": 1,
    "弐": 1,
    "匂": null,
    "肉": 4,
    "虹": 1,
    "日": 5,
    "入": 5,
    "乳": 2,
    "尿": 1,
    "任": 3,
    "妊": 1,
    "忍": 1,
    "認": 3,
    "寧": 1,
    "熱": 3,
    "年": 5,
    "念": 3,
    "捻": null,
    "粘": 1,
    "燃": 2,
    "悩": 2,
    "納": 1,
    "能": 3,
    "脳": 2,
    "農": 2,
    "濃": 2,
    "把": 1,
    "波": 2,
    "派": 1,
    "破": 3,
    "覇": 1,
    "馬": 3,
    "婆": 1,
    "罵": null,
    "拝": 2,
    "杯": 3,
    "背": 3,
    "肺": 1,
    "俳": 1,
    "配": 3,
    "排": 1,
    "敗": 3,
    "廃": 1,
    "輩": 1,
    "売": 4,
    "倍": 2,
    "梅": 1,
    "培": 1,
    "陪": 1,
    "媒": 1,
    "買": 4,
    "賠": 1,
    "白": 5,
    "伯": 1,
    "拍": 1,
    "泊": 2,
    "迫": 1,
    "剝": null,
    "舶": 1,
    "博": 1,
    "薄": 2,
    "麦": 2,
    "漠": 1,
    "縛": 1,
    "爆": 2,
    "箱": 3,
    "箸": null,
    "畑": null,
    "肌": 2,
    "八": 5,
    "鉢": 1,
    "発": 4,
    "髪": 3,
    "伐": 1,
    "抜": 3,
    "罰": 1,
    "閥": 1,
    "反": 3,
    "半": 5,
    "氾": null,
    "犯": 3,
    "帆": 1,
    "汎": null,
    "伴": 1,
    "判": 3,
    "坂": 2,
    "阪": null,
    "板": 2,
    "版": 2,
    "班": 1,
    "畔": 1,
    "般": 2,
    "販": 2,
    "斑": null,
    "飯": 4,
    "搬": 1,
    "煩": 1,
    "頒": 1,
    "範": 1,
    "繁": 1,
    "藩": 1,
    "晩": 3,
    "番": 3,
    "蛮": 1,
    "盤": 1,
    "比": 2,
    "皮": 2,
    "妃": 1,
    "否": 3,
    "批": 1,
    "彼": 3,
    "披": 1,
    "肥": 1,
    "非": 3,
    "卑": 1,
    "飛": 3,
    "疲": 3,
    "秘": 1,
    "被": 2,
    "悲": 3,
    "扉": 1,
    "費": 3,
    "碑": 1,
    "罷": 1,
    "避": 1,
    "尾": 1,
    "眉": 1,
    "美": 3,
    "備": 3,
    "微": 1,
    "鼻": 2,
    "膝": null,
    "肘": null,
    "匹": 2,
    "必": 3,
    "泌": 1,
    "筆": 2,
    "姫": 1,
    "百": 5,
    "氷": 2,
    "表": 3,
    "俵": 1,
    "票": 1,
    "評": 1,
    "漂": 1,
    "標": 1,
    "苗": 1,
    "秒": 2,
    "病": 4,
    "描": 1,
    "猫": 3,
    "品": 4,
    "浜": 1,
    "貧": 3,
    "賓": 1,
    "頻": 1,
    "敏": 1,
    "瓶": 2,
    "不": 4,
    "夫": 3,
    "父": 5,
    "付": 3,
    "布": 2,
    "扶": 1,
    "府": 2,
    "怖": 3,
    "阜": null,
    "附": 1,
    "訃": null,
    "負": 3,
    "赴": 1,
    "浮": 3,
    "婦": 3,
    "符": 2,
    "富": 3,
    "普": 2,
    "腐": 1,
    "敷": 1,
    "膚": 2,
    "賦": 1,
    "譜": 1,
    "侮": 1,
    "武": 2,
    "部": 3,
    "舞": 3,
    "封": 2,
    "風": 4,
    "伏": 1,
    "服": 4,
    "副": 2,
    "幅": 2,
    "復": 2,
    "福": 3,
    "腹": 3,
    "複": 2,
    "覆": 1,
    "払": 3,
    "沸": 2,
    "仏": 2,
    "物": 4,
    "粉": 2,
    "紛": 1,
    "雰": 1,
    "噴": 1,
    "墳": 1,
    "憤": 1,
    "奮": 1,
    "分": null,
    "文": 4,
    "聞": 5,
    "丙": 1,
    "平": 3,
    "兵": 2,
    "併": 1,
    "並": 2,
    "柄": 1,
    "陛": 1,
    "閉": 3,
    "塀": 1,
    "幣": 1,
    "弊": 1,
    "蔽": null,
    "餅": null,
    "米": 3,
    "壁": 1,
    "璧": null,
    "癖": 1,
    "別": 4,
    "蔑": null,
    "片": 2,
    "辺": 2,
    "返": 3,
    "変": 3,
    "偏": 1,
    "遍": 1,
    "編": 2,
    "弁": 1,
    "便": 3,
    "勉": 4,
    "歩": 4,
    "保": 1,
    "哺": null,
    "捕": 3,
    "補": 2,
    "舗": 1,
    "母": 5,
    "募": 2,
    "墓": 1,
    "慕": 1,
    "暮": 3,
    "簿": 1,
    "方": 4,
    "包": 2,
    "芳": 1,
    "邦": 1,
    "奉": 1,
    "宝": 2,
    "抱": 3,
    "放": 3,
    "法": 3,
    "泡": 1,
    "胞": 1,
    "俸": 1,
    "倣": 1,
    "峰": 1,
    "砲": 1,
    "崩": 1,
    "訪": 3,
    "報": 3,
    "蜂": null,
    "豊": 2,
    "飽": 1,
    "褒": 1,
    "縫": 1,
    "亡": 3,
    "乏": 1,
    "忙": 3,
    "坊": null,
    "妨": 1,
    "忘": 3,
    "防": 2,
    "房": 1,
    "肪": 1,
    "某": 1,
    "冒": 1,
    "剖": 1,
    "紡": 1,
    "望": 3,
    "傍": 1,
    "帽": 2,
    "棒": 2,
    "貿": 2,
    "貌": null,
    "暴": 2,
    "膨": 1,
    "謀": 1,
    "頰": null,
    "北": 5,
    "木": 5,
    "朴": 1,
    "牧": 1,
    "睦": 1,
    "僕": 1,
    "墨": 1,
    "撲": 1,
    "没": 1,
    "勃": null,
    "堀": 1,
    "本": 5,
    "奔": 1,
    "翻": 1,
    "凡": 1,
    "盆": 1,
    "麻": 1,
    "摩": 1,
    "磨": 2,
    "魔": 1,
    "毎": 5,
    "妹": 4,
    "枚": 2,
    "昧": null,
    "埋": 2,
    "幕": 1,
    "膜": 1,
    "枕": null,
    "又": 1,
    "末": 3,
    "抹": 1,
    "万": 5,
    "満": 3,
    "慢": 1,
    "漫": 1,
    "未": 3,
    "味": 4,
    "魅": 1,
    "岬": 1,
    "密": 1,
    "蜜": null,
    "脈": 1,
    "妙": 1,
    "民": 3,
    "眠": 3,
    "矛": 1,
    "務": 3,
    "無": null,
    "夢": 3,
    "霧": 1,
    "娘": 3,
    "名": 5,
    "命": 3,
    "明": 4,
    "迷": 3,
    "冥": null,
    "盟": 1,
    "銘": 1,
    "鳴": 3,
    "滅": 1,
    "免": 1,
    "面": 3,
    "綿": 2,
    "麺": null,
    "茂": 1,
    "模": 1,
    "毛": 2,
    "妄": 1,
    "盲": 1,
    "耗": 1,
    "猛": 1,
    "網": 1,
    "目": 4,
    "黙": 1,
    "門": 2,
    "紋": 1,
    "問": 4,
    "冶": 1,
    "夜": 4,
    "野": 4,
    "弥": 1,
    "厄": 1,
    "役": 3,
    "約": 3,
    "訳": 1,
    "薬": 3,
    "躍": 1,
    "闇": null,
    "由": 3,
    "油": 2,
    "喩": null,
    "愉": 1,
    "諭": 1,
    "輸": 2,
    "癒": 1,
    "唯": 1,
    "友": 5,
    "有": 4,
    "勇": 2,
    "幽": 1,
    "悠": 1,
    "郵": 2,
    "湧": 1,
    "猶": 1,
    "裕": 1,
    "遊": 3,
    "雄": 1,
    "誘": 1,
    "憂": 1,
    "融": 1,
    "優": 3,
    "与": 3,
    "予": 3,
    "余": 3,
    "誉": 1,
    "預": 2,
    "幼": 2,
    "用": 4,
    "羊": 1,
    "妖": null,
    "洋": 4,
    "要": 3,
    "容": 3,
    "庸": 1,
    "揚": 1,
    "揺": 1,
    "葉": 3,
    "陽": 3,
    "溶": 2,
    "腰": 2,
    "様": 3,
    "瘍": null,
    "踊": 2,
    "窯": 1,
    "養": 1,
    "擁": 1,
    "謡": 1,
    "曜": 4,
    "抑": 1,
    "沃": null,
    "浴": 2,
    "欲": 3,
    "翌": 2,
    "翼": 1,
    "拉": null,
    "裸": 1,
    "羅": 1,
    "来": 5,
    "雷": 1,
    "頼": 3,
    "絡": 2,
    "落": 3,
    "酪": 1,
    "辣": null,
    "乱": 2,
    "卵": 2,
    "覧": 1,
    "濫": 1,
    "藍": 1,
    "欄": 1,
    "吏": 1,
    "利": 3,
    "里": null,
    "理": 4,
    "痢": 1,
    "裏": 2,
    "履": 1,
    "璃": 1,
    "離": 1,
    "陸": 2,
    "立": 4,
    "律": 2,
    "慄": null,
    "略": 2,
    "柳": 1,
    "流": 3,
    "留": 3,
    "竜": 1,
    "粒": 2,
    "隆": 1,
    "硫": 1,
    "侶": null,
    "旅": 4,
    "虜": 1,
    "慮": 1,
    "了": 2,
    "両": 3,
    "良": 3,
    "料": 4,
    "涼": 2,
    "猟": 1,
    "陵": 1,
    "量": 2,
    "僚": 1,
    "領": 2,
    "寮": 1,
    "療": 2,
    "瞭": 1,
    "糧": 1,
    "力": 4,
    "緑": 2,
    "林": 2,
    "厘": 1,
    "倫": 1,
    "輪": 2,
    "隣": 1,
    "臨": 1,
    "瑠": 1,
    "涙": 2,
    "累": 1,
    "塁": 1,
    "類": 3,
    "令": 2,
    "礼": 3,
    "冷": 3,
    "励": 1,
    "戻": 3,
    "例": 3,
    "鈴": 1,
    "零": 2,
    "霊": 1,
    "隷": 1,
    "齢": 2,
    "麗": 1,
    "暦": 1,
    "歴": 2,
    "列": 3,
    "劣": 1,
    "烈": 1,
    "裂": 1,
    "恋": 2,
    "連": 3,
    "廉": 1,
    "練": 2,
    "錬": 1,
    "呂": 1,
    "炉": 1,
    "賂": null,
    "路": 3,
    "露": 1,
    "老": 3,
    "労": 3,
    "弄": null,
    "郎": 1,
    "朗": 1,
    "浪": 1,
    "廊": 1,
    "楼": 1,
    "漏": 1,
    "籠": null,
    "六": 5,
    "録": 2,
    "麓": null,
    "論": 3,
    "和": 3,
    "話": 5,
    "賄": 1,
    "脇": null,
    "惑": 1,
    "枠": 1,
    "湾": 2,
    "腕": 2,
    "丑": 1,
    "丞": 1,
    "乃": 1,
    "之": 1,
    "乎": null,
    "乘": null,
    "也": 1,
    "云": null,
    "亘": 1,
    "亙": null,
    "些": null,
    "亞": null,
    "亥": 1,
    "亦": 1,
    "亨": 1,
    "亮": 1,
    "仔": null,
    "伊": 1,
    "伍": 1,
    "伶": 1,
    "伽": 1,
    "佃": null,
    "佑": 1,
    "佛": null,
    "侃": 1,
    "來": null,
    "侑": 1,
    "俄": null,
    "俐": null,
    "俠": null,
    "俣": null,
    "俱": null,
    "倖": 1,
    "倦": null,
    "倭": 1,
    "偲": 1,
    "傭": null,
    "傳": null,
    "僞": null,
    "價": null,
    "儉": null,
    "儲": null,
    "允": 1,
    "兎": null,
    "兒": null,
    "兜": null,
    "其": null,
    "冨": null,
    "冴": 1,
    "凉": null,
    "凌": 1,
    "凛": null,
    "凜": 1,
    "凧": null,
    "凪": 1,
    "凰": null,
    "凱": 1,
    "函": null,
    "剩": null,
    "劉": null,
    "劍": null,
    "劫": null,
    "勁": 1,
    "勳": null,
    "勺": 1,
    "勿": null,
    "匁": 1,
    "匡": 1,
    "卜": null,
    "卯": 1,
    "卷": null,
    "卽": null,
    "卿": null,
    "厨": null,
    "厩": null,
    "叉": null,
    "叡": 1,
    "叢": null,
    "只": 1,
    "叶": 1,
    "吞": null,
    "吻": null,
    "吾": null,
    "哉": 1,
    "哨": null,
    "哩": null,
    "啄": 1,
    "喋": null,
    "喧": null,
    "喬": 1,
    "單": null,
    "喰": null,
    "嘉": 1,
    "嘗": null,
    "嘩": null,
    "噂": null,
    "噌": null,
    "嚴": null,
    "圃": null,
    "圈": null,
    "國": null,
    "圓": null,
    "團": null,
    "圭": 1,
    "坐": null,
    "坦": null,
    "埜": null,
    "埴": null,
    "堯": null,
    "堰": null,
    "堵": null,
    "堺": null,
    "塙": null,
    "增": null,
    "壕": null,
    "壘": null,
    "壞": null,
    "壬": null,
    "壯": null,
    "壽": null,
    "夷": null,
    "奄": null,
    "奎": 1,
    "套": null,
    "奧": null,
    "奬": null,
    "姥": null,
    "姪": null,
    "娃": null,
    "娩": null,
    "嬉": 1,
    "孃": null,
    "孜": null,
    "孟": 1,
    "宋": null,
    "宏": 1,
    "宕": null,
    "宥": 1,
    "寅": 1,
    "寓": null,
    "寢": null,
    "實": null,
    "寬": null,
    "寵": null,
    "將": null,
    "專": null,
    "尖": null,
    "尤": null,
    "尭": 1,
    "屑": null,
    "峨": null,
    "峯": null,
    "峻": 1,
    "峽": null,
    "崚": 1,
    "嵩": 1,
    "嵯": 1,
    "嶋": null,
    "嶺": 1,
    "巌": 1,
    "巖": null,
    "巢": null,
    "巫": null,
    "已": null,
    "巳": 1,
    "巴": 1,
    "巷": null,
    "巽": 1,
    "帖": null,
    "帶": null,
    "幌": null,
    "幡": null,
    "庄": 1,
    "庇": null,
    "庚": null,
    "庵": null,
    "廟": null,
    "廣": null,
    "廳": null,
    "廻": null,
    "廿": null,
    "弘": 1,
    "弛": null,
    "彈": null,
    "彌": null,
    "彗": 1,
    "彦": 1,
    "彪": 1,
    "彬": 1,
    "從": null,
    "徠": null,
    "徵": null,
    "德": null,
    "徽": null,
    "忽": null,
    "怜": 1,
    "恆": null,
    "恕": 1,
    "恢": null,
    "恰": null,
    "悉": null,
    "悌": 1,
    "惇": 1,
    "惚": null,
    "惟": 1,
    "惠": null,
    "惡": null,
    "惣": 1,
    "惹": null,
    "惺": null,
    "愼": null,
    "慧": 1,
    "憐": null,
    "應": null,
    "懷": null,
    "戊": null,
    "或": null,
    "戟": null,
    "戰": null,
    "戲": null,
    "托": null,
    "拂": null,
    "拔": null,
    "拜": null,
    "按": null,
    "挺": null,
    "挽": null,
    "捧": null,
    "捲": null,
    "捷": 1,
    "捺": 1,
    "掠": null,
    "掬": null,
    "揃": null,
    "揭": null,
    "搖": null,
    "搜": null,
    "摑": null,
    "摺": null,
    "撒": null,
    "撞": null,
    "撫": null,
    "播": null,
    "撰": null,
    "擊": null,
    "擢": null,
    "攝": null,
    "收": null,
    "敍": null,
    "敦": 1,
    "斐": 1,
    "斡": null,
    "斧": null,
    "斯": null,
    "於": 1,
    "旭": 1,
    "昂": 1,
    "昊": null,
    "昌": 1,
    "昏": null,
    "昴": 1,
    "晃": 1,
    "晄": null,
    "晋": 1,
    "晏": 1,
    "晒": null,
    "晚": null,
    "晝": null,
    "晟": 1,
    "晦": null,
    "晨": 1,
    "智": 1,
    "暉": 1,
    "暢": 1,
    "曆": null,
    "曉": null,
    "曙": 1,
    "曝": null,
    "曳": null,
    "曾": null,
    "朋": 1,
    "朔": 1,
    "李": 1,
    "杏": 1,
    "杖": null,
    "杜": 1,
    "杭": null,
    "杵": null,
    "杷": null,
    "枇": null,
    "柊": 1,
    "柏": null,
    "柑": null,
    "柘": null,
    "柚": 1,
    "柴": null,
    "柾": 1,
    "栖": null,
    "栗": 1,
    "栞": 1,
    "桂": 1,
    "桐": 1,
    "桔": null,
    "桧": null,
    "桶": null,
    "梁": null,
    "梓": 1,
    "梛": null,
    "條": null,
    "梢": 1,
    "梧": 1,
    "梯": null,
    "梶": null,
    "棲": null,
    "椀": null,
    "椋": 1,
    "椛": null,
    "椰": 1,
    "椿": 1,
    "楊": 1,
    "楓": 1,
    "楕": null,
    "楚": null,
    "楠": 1,
    "楢": null,
    "楯": null,
    "榊": null,
    "榎": null,
    "榛": 1,
    "榮": null,
    "槇": null,
    "槌": null,
    "槍": null,
    "槙": 1,
    "槻": 1,
    "樂": null,
    "樋": null,
    "樟": null,
    "樣": null,
    "樫": null,
    "樺": 1,
    "樽": null,
    "橘": 1,
    "橙": null,
    "橫": null,
    "檀": 1,
    "檎": null,
    "檜": null,
    "檢": null,
    "櫂": null,
    "櫓": null,
    "櫛": null,
    "櫻": null,
    "欣": 1,
    "欽": 1,
    "歎": null,
    "此": null,
    "步": null,
    "歷": null,
    "殆": null,
    "毅": 1,
    "每": null,
    "毘": null,
    "毬": 1,
    "氣": null,
    "汀": null,
    "汐": 1,
    "汝": null,
    "汲": null,
    "沌": null,
    "沓": null,
    "沫": null,
    "洛": null,
    "洲": 1,
    "洵": 1,
    "洸": 1,
    "浩": 1,
    "浬": null,
    "涉": null,
    "淀": null,
    "淋": null,
    "淚": null,
    "淨": null,
    "淳": 1,
    "淵": null,
    "渚": 1,
    "渥": 1,
    "渴": null,
    "渾": null,
    "湊": null,
    "湘": null,
    "湛": null,
    "溜": null,
    "溢": null,
    "溫": null,
    "滉": 1,
    "滯": null,
    "漕": null,
    "漣": null,
    "漱": 1,
    "澁": null,
    "澪": 1,
    "濕": null,
    "濡": null,
    "瀕": null,
    "瀧": null,
    "瀨": null,
    "灘": null,
    "灸": null,
    "灼": null,
    "烏": null,
    "焚": null,
    "焰": null,
    "煉": null,
    "煌": null,
    "煤": null,
    "熙": 1,
    "燈": null,
    "燎": 1,
    "燒": null,
    "燕": null,
    "燦": 1,
    "燭": null,
    "燿": 1,
    "爭": null,
    "爲": null,
    "爾": 1,
    "牒": null,
    "牟": null,
    "牡": null,
    "牽": null,
    "犀": null,
    "狀": null,
    "狹": null,
    "狼": null,
    "猪": 1,
    "獅": null,
    "獸": null,
    "玖": 1,
    "玲": 1,
    "珀": null,
    "珂": null,
    "珈": null,
    "珊": null,
    "琉": 1,
    "琢": 1,
    "琥": null,
    "琳": 1,
    "琵": null,
    "琶": null,
    "瑚": 1,
    "瑛": 1,
    "瑞": 1,
    "瑳": 1,
    "瑶": 1,
    "瓜": null,
    "瓢": null,
    "甥": null,
    "甫": 1,
    "畠": null,
    "畢": null,
    "疊": null,
    "疋": null,
    "疏": null,
    "瘦": null,
    "皐": 1,
    "皓": 1,
    "盃": null,
    "盜": null,
    "盡": null,
    "眞": null,
    "眸": 1,
    "瞥": null,
    "矩": null,
    "砥": null,
    "砦": null,
    "砧": null,
    "硯": null,
    "碎": null,
    "碓": null,
    "碗": null,
    "碧": 1,
    "碩": 1,
    "磐": null,
    "磯": 1,
    "祁": null,
    "祇": null,
    "祐": 1,
    "祕": null,
    "祢": null,
    "祷": null,
    "祿": null,
    "禄": 1,
    "禎": 1,
    "禪": null,
    "禮": null,
    "禰": null,
    "禱": null,
    "禽": null,
    "禾": null,
    "秤": null,
    "秦": 1,
    "稀": 1,
    "稔": 1,
    "稜": 1,
    "稟": null,
    "稻": null,
    "穗": null,
    "穣": 1,
    "穰": null,
    "穹": null,
    "穿": null,
    "窄": null,
    "窪": null,
    "窺": null,
    "竣": 1,
    "竪": null,
    "竺": null,
    "竿": null,
    "笈": null,
    "笙": 1,
    "笠": null,
    "笹": 1,
    "筈": null,
    "筑": null,
    "箔": null,
    "箕": null,
    "篇": null,
    "篠": null,
    "簞": null,
    "簾": null,
    "籾": null,
    "粟": null,
    "粥": null,
    "粹": null,
    "糊": null,
    "紐": null,
    "紗": 1,
    "紘": 1,
    "紬": 1,
    "絃": 1,
    "絆": null,
    "絢": 1,
    "綜": 1,
    "綠": null,
    "綴": null,
    "綸": 1,
    "綺": 1,
    "綾": 1,
    "緋": 1,
    "緖": null,
    "緣": null,
    "縞": null,
    "縣": null,
    "縱": null,
    "繡": null,
    "繫": null,
    "纂": null,
    "纏": null,
    "纖": null,
    "羚": null,
    "翔": 1,
    "翠": 1,
    "耀": 1,
    "而": null,
    "耶": 1,
    "耽": null,
    "聡": 1,
    "聽": null,
    "肇": 1,
    "肋": null,
    "肴": null,
    "胡": 1,
    "胤": 1,
    "脩": 1,
    "脹": 1,
    "腔": null,
    "膏": null,
    "臟": null,
    "臥": null,
    "與": null,
    "舜": 1,
    "舵": null,
    "芙": 1,
    "芥": null,
    "芦": null,
    "芭": null,
    "芹": 1,
    "苑": 1,
    "苔": null,
    "苺": null,
    "茄": 1,
    "茅": 1,
    "茉": 1,
    "茜": 1,
    "茸": null,
    "荻": null,
    "莉": 1,
    "莊": null,
    "莞": 1,
    "莫": null,
    "菅": null,
    "菖": 1,
    "菩": null,
    "菫": 1,
    "菱": null,
    "萄": null,
    "萊": null,
    "萌": 1,
    "萠": null,
    "萩": 1,
    "萬": null,
    "萱": null,
    "葡": null,
    "董": null,
    "葦": null,
    "葵": 1,
    "葺": null,
    "蒐": null,
    "蒔": 1,
    "蒙": null,
    "蒲": null,
    "蒼": 1,
    "蓉": 1,
    "蓑": null,
    "蓬": null,
    "蓮": 1,
    "蔓": null,
    "蔣": null,
    "蔦": 1,
    "蔭": null,
    "蕃": null,
    "蕉": 1,
    "蕎": null,
    "蕗": 1,
    "蕨": null,
    "蕪": null,
    "蕾": null,
    "薗": null,
    "薙": null,
    "薩": null,
    "薰": null,
    "藁": null,
    "藏": null,
    "藝": null,
    "藥": null,
    "蘇": null,
    "蘭": 1,
    "虛": null,
    "蝦": null,
    "蝶": 1,
    "螺": null,
    "蟬": null,
    "蟹": null,
    "蠟": null,
    "衞": null,
    "衿": 1,
    "袈": 1,
    "袴": null,
    "裝": null,
    "裟": 1,
    "裡": null,
    "裳": null,
    "襖": null,
    "覽": null,
    "訊": null,
    "訣": null,
    "註": null,
    "詢": 1,
    "詫": null,
    "誼": 1,
    "諄": 1,
    "諏": null,
    "諒": 1,
    "諺": null,
    "謂": null,
    "謠": null,
    "讃": null,
    "讓": null,
    "豹": null,
    "貰": null,
    "賑": null,
    "賣": null,
    "賴": null,
    "赳": 1,
    "跨": null,
    "蹄": null,
    "蹟": null,
    "輔": 1,
    "輯": null,
    "輿": null,
    "轉": null,
    "轟": null,
    "辰": 1,
    "辻": null,
    "辿": null,
    "迂": null,
    "迄": null,
    "迦": null,
    "迪": 1,
    "逗": null,
    "這": null,
    "逞": null,
    "逢": null,
    "遁": null,
    "遙": null,
    "遥": 1,
    "遼": 1,
    "邑": 1,
    "郁": 1,
    "郞": null,
    "鄭": null,
    "酉": 1,
    "醇": null,
    "醉": null,
    "醍": null,
    "醐": null,
    "醬": null,
    "釀": null,
    "釉": null,
    "釘": null,
    "釧": null,
    "銑": 1,
    "鋒": null,
    "鋸": null,
    "錄": null,
    "錆": null,
    "錐": null,
    "錘": 1,
    "錫": null,
    "鍊": null,
    "鍬": null,
    "鎧": null,
    "鎭": null,
    "鑄": null,
    "閃": null,
    "閏": null,
    "閤": null,
    "阿": 1,
    "陀": null,
    "陷": null,
    "隈": null,
    "險": null,
    "隼": 1,
    "雀": null,
    "雁": null,
    "雛": 1,
    "雜": null,
    "雫": null,
    "霞": 1,
    "靖": 1,
    "靜": null,
    "鞄": null,
    "鞍": null,
    "鞘": null,
    "鞠": 1,
    "鞭": null,
    "頁": null,
    "頌": 1,
    "頗": null,
    "顚": null,
    "顯": null,
    "颯": 1,
    "飜": null,
    "饗": null,
    "馨": 1,
    "馳": null,
    "馴": null,
    "駈": null,
    "駕": null,
    "駿": 1,
    "騷": null,
    "驍": null,
    "驗": null,
    "髮": null,
    "魁": 1,
    "魯": null,
    "鮎": 1,
    "鯉": 1,
    "鯛": 1,
    "鰯": null,
    "鱒": null,
    "鱗": null,
    "鳩": 1,
    "鳳": 1,
    "鳶": null,
    "鴨": null,
    "鴻": 1,
    "鵜": null,
    "鵬": 1,
    "鷄": null,
    "鷗": null,
    "鷲": null,
    "鷹": 1,
    "鷺": null,
    "麒": null,
    "麟": 1,
    "麿": 1,
    "黃": null,
    "黎": 1,
    "黑": null,
    "默": null,
    "黛": 1,
    "鼎": null,
    "齊": null,
    "龍": null,
    "欄": null,
    "廊": null,
    "朗": null,
    "虜": null,
    "類": null,
    "猪": null,
    "神": null,
    "祥": null,
    "福": null,
    "諸": null,
    "都": null,
    "侮": null,
    "勤": null,
    "卑": null,
    "墨": null,
    "層": null,
    "悔": null,
    "梅": null,
    "煮": null,
    "琢": null,
    "碑": null,
    "祐": null,
    "祖": null,
    "禍": null,
    "穀": null,
    "練": null,
    "署": null,
    "者": null,
    "臭": null,
    "賓": null,
    "贈": null,
    "響": null,
};
